/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface V2Reservation {
  /** 등록되지 않은 사용자 여부 */
  isUnregisteredUser?: boolean;
  /** 주간 요일 배열 */
  weeklyDays?: number[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 취소 여부 */
  isCanceled?: boolean;
  /** 첫 방문 여부 */
  isFirstVisit?: boolean;
  /** 예약 ID */
  _id: string;
  /** 병원 ID */
  hospitalID: string;
  /** 그룹(부서) ID */
  groupID: string;
  /** 컬럼(담당자) ID */
  columnID: string;
  /** 프로그램 ID */
  programID: string;
  /** 상태 ID */
  statusID: string;
  /** 사용자 ID */
  userID: string;
  /** 서비스 ID */
  hserviceID: string;
  /**
   * 시작 일시
   * @format date-time
   */
  startedAt?: string;
  /**
   * 종료 일시
   * @format date-time
   */
  endedAt?: string;
  /** 메모 */
  note?: string;
  /** 작성자 ID */
  writerID: string;
  /** 작성자 유형 */
  writerType?: number;
  /** 사용자 이름 */
  userName?: string;
  /** 그룹(부서) 제목 */
  groupTitle?: string;
  /** 컬럼(담당자) 제목 */
  columnTitle?: string;
  /** 프로그램 제목 */
  programTitle?: string;
  /** 상태 제목 */
  statusTitle?: string;
  /** 작성자 이름 */
  writerName?: string;
  /** 지속 시간(분) */
  duration?: number;
  /**
   * 생성 일시
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 일시
   * @format date-time
   */
  updatedAt?: string;
  /** 버전 */
  __v?: number;
  /** 예약 ID */
  id: string;
}

export interface ReservationDetail {
  /** 등록되지 않은 사용자 여부 */
  isUnregisteredUser?: boolean;
  /** 주간 요일 배열 */
  weeklyDays?: number[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 취소 여부 */
  isCanceled?: boolean;
  /** 첫 방문 여부 */
  isFirstVisit?: boolean;
  /** 예약 ID */
  _id: string;
  /** 병원 ID */
  hospitalID: string;
  groupID?: ReservationGroupDetailForReservation;
  columnID?: Column;
  programID?: Program;
  statusID?: Status;
  /** 사용자 ID */
  userID: string;
  hserviceID?: HService;
  /**
   * 시작 일시
   * @format date-time
   */
  startedAt?: string;
  /**
   * 종료 일시
   * @format date-time
   */
  endedAt?: string;
  /** 메모 */
  note?: string;
  writerID: UserNameAndType;
  /** 작성자 유형 */
  writerType?: number;
  /** 사용자 이름 */
  userName?: string;
  /** 그룹(부서) 제목 */
  groupTitle?: string;
  /** 컬럼(담당자) 제목 */
  columnTitle?: string;
  /** 프로그램 제목 */
  programTitle?: string;
  /** 상태 제목 */
  statusTitle?: string;
  /** 작성자 이름 */
  writerName?: string;
  /** 지속 시간(분) */
  duration?: number;
  /**
   * 생성 일시
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 일시
   * @format date-time
   */
  updatedAt?: string;
  /** 버전 */
  __v?: number;
  /** 예약 ID */
  id: string;
}

/** @example {"_id":"65f273e83f8eda49509e6bdf","title":"일반 예약","hospitalID":"507f1f77bcf86cd799439011","sortNum":1,"usingReservationNotification":true,"usingReservationBNotification":false,"columns":["507f1f77bcf86cd799439011","507f1f77bcf86cd799439012"],"modifierID":"507f1f77bcf86cd799439013","isRemoved":false,"createdAt":"2023-04-01T09:00:00.000Z","updatedAt":"2023-04-04T09:00:00.000Z","modifiedAt":"2023-04-04T09:00:00.000Z"} */
export interface ReservationGroupDetailForReservation {
  /** 예약 그룹 ID */
  _id: string;
  /** 예약 그룹 제목 */
  title?: string;
  /** 병원 ID 참조 */
  hospitalID: string;
  /** 정렬 번호 */
  sortNum: number;
  /**
   * 예약 알림 사용 여부
   * @default false
   */
  usingReservationNotification?: boolean;
  /**
   * 예약 B 알림 사용 여부
   * @default false
   */
  usingReservationBNotification?: boolean;
  /** 예약 컬럼 ID 배열 */
  columns?: string[];
  /** 수정자 ID 참조 */
  modifierID?: string;
  /**
   * 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /**
   * 생성 일시
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 일시
   * @format date-time
   */
  updatedAt?: string;
  /**
   * 수정된 일시
   * @format date-time
   */
  modifiedAt?: string;
}

export interface Column {
  notificationUsers?: any[];
  programs?: any[];
  /** @example true */
  usingDefaultBoldInterval?: boolean;
  /** @example 60 */
  boldInterval?: number;
  boldTimeIntervals?: any[];
  /** @example false */
  isActive?: boolean;
  appPrograms?: any[];
  /** @example "day" */
  canCreateType?: string;
  /** @example 1 */
  possibleCreateRange?: number;
  /** @example true */
  usingSameDayBlock?: boolean;
  /** @example "day" */
  sameDayBlockType?: string;
  /** @example 1 */
  sameDayBlockDuration?: number;
  /** @example false */
  canModify?: boolean;
  /** @example "day" */
  canModifyType?: string;
  /** @example 1 */
  possibleModifyRange?: number;
  /** @example false */
  canCancel?: boolean;
  /** @example "day" */
  canCancelType?: string;
  /** @example 1 */
  possibleCancelRange?: number;
  /** @example true */
  usingDefaultAppInterval?: boolean;
  /** @example 60 */
  appInterval?: number;
  appTimeIntervals?: any[];
  /** @example 1 */
  appMaxCapacity?: number;
  /** @example true */
  isRemoved?: boolean;
  /** @example "65f2747a3f8eda49509e6c2f" */
  _id: string;
  /** @example "63d7bafc1374672f7c407efd" */
  hospitalID: string;
  /** @example "1번원장실1" */
  title?: string;
  /** @example "65f2744f3f8eda49509e6c19" */
  groupID: string;
  /** @example "613aa681cb516152eed8fdb3" */
  modifierID?: string;
  /**
   * @format date-time
   * @example "2024-03-14T05:51:09.383Z"
   */
  modifiedAt?: string;
  /**
   * @format date-time
   * @example "2024-03-14T03:52:26.325Z"
   */
  createdAt?: string;
  /**
   * @format date-time
   * @example "2024-03-14T09:14:40.797Z"
   */
  updatedAt?: string;
  /** @example 55 */
  sortNum?: number;
  /** @example 0 */
  __v?: number;
  /**
   * @format date-time
   * @example "2024-03-14T03:53:49.592Z"
   */
  removedAt?: string;
}

export interface Program {
  /**
   * 프로그램 ID
   * @example "65f2744f3f8eda49509e6c19"
   */
  _id: string;
  /**
   * 병원 ID
   * @example "65f2744f3f8eda49509e6c19"
   */
  hospitalID: string;
  /**
   * 예약 시간
   * @example 30
   */
  duration?: number;
  /**
   * 프로그램 설명
   * @example "1번원장실1"
   */
  description?: string;
  /** @example "1번원장실1" */
  title?: string;
  /** @example "613aa681cb516152eed8fdb3" */
  modifierID?: string;
  /**
   * @format date-time
   * @example "2024-03-14T05:51:09.383Z"
   */
  modifiedAt?: string;
  /**
   * @format date-time
   * @example "2024-03-14T03:52:26.325Z"
   */
  createdAt?: string;
  /**
   * @format date-time
   * @example "2024-03-14T09:14:40.797Z"
   */
  updatedAt?: string;
  /** @example 55 */
  sortNum?: number;
  /**
   * 삭제 여부
   * @example true
   */
  is_removed?: boolean;
}

export interface Status {
  /** 예약 상태 ID */
  _id: string;
  /** 병원 ID */
  hospitalID: string;
  /** 상태 제목 */
  title?: string;
  /**
   * 방문 상태 여부
   * @default false
   */
  isVisitStatus?: boolean;
  /**
   * 취소 상태 여부
   * @default false
   */
  isCancelStatus?: boolean;
  /**
   * 기본 상태 여부
   * @default false
   */
  isDefault?: boolean;
  /** 팔레트 인덱스 */
  paletteIndex?: number;
  /** 사용자 정의 팔레트 인덱스 */
  customPaletteIndex?: number;
  /** 정렬 번호 */
  sortNum?: number;
  /**
   * 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /** 수정자 ID */
  modifierID?: string;
  /**
   * 생성 일시
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 일시
   * @format date-time
   */
  updatedAt?: string;
  /**
   * 수정된 일시
   * @format date-time
   */
  modifiedAt?: string;
}

export interface HService {
  /** 서비스 ID */
  _id: string;
  /** 서비스 대상이 되는 유저 ID */
  userID: string;
  /** 서비스 대상의 이름 */
  name: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: string;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: string;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID: string;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: string;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun: boolean;
  /** 모바일에서 환자가 서비스 이용 중단 요청한 경우, 시스템 또는 어드민 수준에서 특정 환자를 서비스 중단 처리한 경우 체크 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface ReservationDetailForNext {
  /** 등록되지 않은 사용자 여부 */
  isUnregisteredUser?: boolean;
  /** 주간 요일 배열 */
  weeklyDays?: number[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 취소 여부 */
  isCanceled?: boolean;
  /** 첫 방문 여부 */
  isFirstVisit?: boolean;
  /** 예약 ID */
  _id: string;
  /** 병원 ID */
  hospitalID: string;
  groupID?: ReservationGroupDetailForReservation;
  columnID?: Column;
  programID?: Program;
  statusID?: Status;
  /** 사용자 ID */
  userID: string;
  hserviceID?: HService;
  /**
   * 시작 일시
   * @format date-time
   */
  startedAt?: string;
  /**
   * 종료 일시
   * @format date-time
   */
  endedAt?: string;
  /** 메모 */
  note?: string;
  /** 작성자 ID */
  writerID: string;
  /** 작성자 유형 */
  writerType?: number;
  /** 사용자 이름 */
  userName?: string;
  /** 그룹(부서) 제목 */
  groupTitle?: string;
  /** 컬럼(담당자) 제목 */
  columnTitle?: string;
  /** 프로그램 제목 */
  programTitle?: string;
  /** 상태 제목 */
  statusTitle?: string;
  /** 작성자 이름 */
  writerName?: string;
  /** 지속 시간(분) */
  duration?: number;
  /**
   * 생성 일시
   * @format date-time
   */
  createdAt?: string;
  /**
   * 수정 일시
   * @format date-time
   */
  updatedAt?: string;
  /** 버전 */
  __v?: number;
  /** 예약 ID */
  id: string;
}

export interface ApiV2ReservationElCountParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
}

export type ApiV2ReservationElCountData = ApiResponse & {
  /**
   * 예약 객체 수
   * @example 3
   */
  data: number;
};

export type ApiV2ReservationElCreateRegistData = ApiResponse & {
  data: V2Reservation;
};

export type ApiV2ReservationElCreateUnregisteredData = ApiResponse & {
  data: V2Reservation;
};

export type ApiV2ReservationElCreateData = ApiResponse & {
  data: V2Reservation;
};

export interface ApiV2ReservationElFindParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiV2ReservationElFindData = ApiResponse & {
  data: ReservationDetail[];
};

export interface ApiV2ReservationElFindHistoryParams {
  /** 병원 ID */
  hospitalID?: string;
  /** 예약 그룹(부서) ID */
  groupID?: string;
  /** 예약 담당자(컬럼) ID */
  columnID?: string;
  /** (optional) 예약 상태 ID 배열. 비어있을 경우 전체 조회 */
  "statusID[]"?: string[];
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약현황 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약현황 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 테스트 계정 여부 플래그. */
  isTest?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
}

export type ApiV2ReservationElFindHistoryData = any;

export interface ApiV2ReservationElFindNextParams {
  /** 병원 아이디 */
  hospitalID: string;
  /** 유저 아이디 */
  userID: string;
}

export type ApiV2ReservationElFindNextData = ApiResponse & {
  data: ReservationDetailForNext;
};

export type ApiV2ReservationElRemoveData = ApiResponse & {
  data: V2Reservation;
};

export type ApiV2ReservationElSendPushData = ApiResponse & {
  data: {
    /** 성공적으로 발송된 푸시 알림 수 */
    successCount?: number;
    /** 발송 실패한 푸시 알림 수 */
    failureCount?: number;
  };
};

export type ApiV2ReservationElUpdateData = ApiResponse & {
  data: V2Reservation;
};

export type ApiV2ReservationMCancelData = any;

export type ApiV2ReservationMCreateData = any;

export interface ApiV2ReservationMFindDateParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 담당자 ID */
  columnID?: string;
  /**
   * 예약 조회를 위한 날짜
   * @default "2024-02-01T00:00:00+09:00"
   */
  date?: string;
}

export type ApiV2ReservationMFindDateData = any;

export interface ApiV2ReservationMFindLastParams {
  /** (required) 유저 ID */
  userID?: string;
  /** (required) 서비스 ID */
  hserviceID?: string;
  /** (optional) 프로그램 ID */
  programID?: string;
}

export type ApiV2ReservationMFindLastData = any;

export interface ApiV2ReservationMFindNextParams {
  /** (required) 유저 아이디 */
  userID?: string;
  /** (required) 서비스 아이디 */
  hserviceID?: string;
}

export type ApiV2ReservationMFindNextData = any;

export interface ApiV2ReservationMFindOneParams {
  /** (required) 예약 ID */
  _id?: string;
}

export type ApiV2ReservationMFindOneData = any;

export interface ApiV2ReservationMFindParams {
  /** (required) 유저 ID */
  userID?: string;
  /** (required) 병원 서비스 ID */
  hserviceID?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /**
   * 예약 조회를 위한 조회 범위 시작 일시
   * @default "2024-02-01T00:00:00+09:00"
   */
  startedAt?: Date;
  /**
   * 예약 조회를 위한 조회 범위 종료 일시
   * @default "2024-02-29T23:59:59+09:00"
   */
  endedAt?: Date;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiV2ReservationMFindData = any;

export interface ApiV2ReservationMPossibledateParams {
  /** (required) 예약 담당자 ID */
  columnID?: string;
}

export type ApiV2ReservationMPossibledateData = any;

export interface ApiV2ReservationMPossibletimeParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 담당자 ID */
  columnID?: string;
  /** (required) 프로그램 ID */
  programID?: string;
  /**
   * 예약 조회를 위한 날짜
   * @default "2024-05-24"
   */
  date?: string;
}

export type ApiV2ReservationMPossibletimeData = any;

export type ApiV2ReservationMUpdateData = any;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElCount
     * @summary 예약 객체 수 조회
     * @request GET:/v3/api/v2reservation/el/count
     * @secure
     * @response `200` `ApiV2ReservationElCountData` 성공적인 응답
     */
    apiV2ReservationElCount: (query: ApiV2ReservationElCountParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElCountData, any>({
        path: `/v3/api/v2reservation/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElCreateRegist
     * @summary 고객 생성 및 예약 객체의 생성
     * @request POST:/v3/api/v2reservation/el/create/regist
     * @secure
     * @response `200` `ApiV2ReservationElCreateRegistData` 요청한 작업이 완료되었습니다.
     */
    apiV2ReservationElCreateRegist: (
      data: {
        /** (required) 고객 이름 */
        name?: string;
        /** (required) 고객 휴대폰번호 */
        phone?: string;
        /** (required) 가입 문자 발송시 발송할 메시지 */
        message?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
        /** (required) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElCreateRegistData, any>({
        path: `/v3/api/v2reservation/el/create/regist`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElCreateUnregistered
     * @summary 예약만 등록하는 예약 객체의 생성
     * @request POST:/v3/api/v2reservation/el/create/unregistered
     * @secure
     * @response `200` `ApiV2ReservationElCreateUnregisteredData` 요청한 작업이 완료되었습니다.
     */
    apiV2ReservationElCreateUnregistered: (
      data: {
        /** (required) 고객 이름 */
        name?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
        /** (required) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElCreateUnregisteredData, any>({
        path: `/v3/api/v2reservation/el/create/unregistered`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElCreate
     * @summary 예약 객체의 생성
     * @request POST:/v3/api/v2reservation/el/create
     * @secure
     * @response `200` `ApiV2ReservationElCreateData` 요청한 작업이 완료되었습니다.
     */
    apiV2ReservationElCreate: (
      data: {
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
        /** (required) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElCreateData, any>({
        path: `/v3/api/v2reservation/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElFind
     * @summary 예약 객체의 조회
     * @request GET:/v3/api/v2reservation/el/find
     * @secure
     * @response `200` `ApiV2ReservationElFindData` 요청한 작업이 완료되었습니다.
     */
    apiV2ReservationElFind: (query: ApiV2ReservationElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElFindData, any>({
        path: `/v3/api/v2reservation/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElFindHistory
     * @summary 치료 예약에 대한 히스토리 조회 (예약 일정)
     * @request GET:/v3/api/v2reservation/el/find/history
     * @secure
     * @response `200` `ApiV2ReservationElFindHistoryData` \[\{v2Reservation\}\] v2Reservation 객체 배열
     */
    apiV2ReservationElFindHistory: (query: ApiV2ReservationElFindHistoryParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElFindHistoryData, any>({
        path: `/v3/api/v2reservation/el/find/history`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElFindNext
     * @summary 다음 예약 객체의 조회
     * @request GET:/v3/api/v2reservation/el/find/next
     * @secure
     * @response `200` `ApiV2ReservationElFindNextData` 다음 예약 객체 조회 성공
     */
    apiV2ReservationElFindNext: (query: ApiV2ReservationElFindNextParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationElFindNextData, any>({
        path: `/v3/api/v2reservation/el/find/next`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElRemove
     * @summary 예약 객체의 삭제
     * @request POST:/v3/api/v2reservation/el/remove
     * @secure
     * @response `200` `ApiV2ReservationElRemoveData` 예약 객체 삭제 성공
     */
    apiV2ReservationElRemove: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElRemoveData, any>({
        path: `/v3/api/v2reservation/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElSendPush
     * @summary 예약 푸시 발송
     * @request POST:/v3/api/v2reservation/el/send/push
     * @secure
     * @response `200` `ApiV2ReservationElSendPushData` 푸시 발송 결과
     */
    apiV2ReservationElSendPush: (
      data: {
        /** (required) 발송할 Push Action 명. create, update, cancel, remove */
        action?: string;
        /** (required) 예약 ID */
        reservationID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElSendPushData, any>({
        path: `/v3/api/v2reservation/el/send/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationElUpdate
     * @summary 예약 객체의 수정. statusID를 isCancelStatus 값이 true인 항목으로 변경 시 취소됨
     * @request POST:/v3/api/v2reservation/el/update
     * @secure
     * @response `200` `ApiV2ReservationElUpdateData` 예약 객체 수정 성공
     */
    apiV2ReservationElUpdate: (
      data: {
        /** (required) 예약 id */
        _id?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /**
         * (optional) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (optional) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 예약 상태 id */
        statusID?: string;
        /** (optional) 환자에 대한 치료내역 수정 시 입력 */
        userNoteContent?: string;
        /** (optional) 예약건에 대한 예약 메모 입력 */
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationElUpdateData, any>({
        path: `/v3/api/v2reservation/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMCancel
     * @summary 예약 취소 (모바일)
     * @request POST:/v3/api/v2reservation/m/cancel
     * @secure
     * @response `200` `ApiV2ReservationMCancelData` \{v2Reservation\} 취소된 예약 컬렉션 객체
     */
    apiV2ReservationMCancel: (
      data: {
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationMCancelData, any>({
        path: `/v3/api/v2reservation/m/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMCreate
     * @summary 예약 생성 (모바일)
     * @request POST:/v3/api/v2reservation/m/create
     * @secure
     * @response `200` `ApiV2ReservationMCreateData` \{v2Reservation\} 생성된 예약 컬렉션 객체
     */
    apiV2ReservationMCreate: (
      data: {
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /** (required) 프로그램 id */
        programID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationMCreateData, any>({
        path: `/v3/api/v2reservation/m/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMFindDate
     * @summary 컬럼 ID 및 특정 일에 대한 다른 유효 예약건들 조회 (모바일)
     * @request GET:/v3/api/v2reservation/m/find/date
     * @secure
     * @response `200` `ApiV2ReservationMFindDateData` \[\{v2Reservation\}\] 취소 및 삭제되지 않은 v2Reservation 객체 배열
     */
    apiV2ReservationMFindDate: (query: ApiV2ReservationMFindDateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindDateData, any>({
        path: `/v3/api/v2reservation/m/find/date`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMFindLast
     * @summary 마지막 예약 객체의 조회
     * @request GET:/v3/api/v2reservation/m/find/last
     * @secure
     * @response `200` `ApiV2ReservationMFindLastData` \{v2Reservation\} v2 예약 객체
     */
    apiV2ReservationMFindLast: (query: ApiV2ReservationMFindLastParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindLastData, any>({
        path: `/v3/api/v2reservation/m/find/last`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMFindNext
     * @summary 다음 예약 객체의 조회
     * @request GET:/v3/api/v2reservation/m/find/next
     * @secure
     * @response `200` `ApiV2ReservationMFindNextData` \{v2Reservation\} 예약 컬렉션 객체
     */
    apiV2ReservationMFindNext: (query: ApiV2ReservationMFindNextParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindNextData, any>({
        path: `/v3/api/v2reservation/m/find/next`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMFindOne
     * @summary 예약 객체 단일 조회 (모바일)
     * @request GET:/v3/api/v2reservation/m/find/one
     * @secure
     * @response `200` `ApiV2ReservationMFindOneData` \{v2Reservation\} v2Reservation 객체
     */
    apiV2ReservationMFindOne: (query: ApiV2ReservationMFindOneParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindOneData, any>({
        path: `/v3/api/v2reservation/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMFind
     * @summary 예약 객체의 조회 (모바일)
     * @request GET:/v3/api/v2reservation/m/find
     * @secure
     * @response `200` `ApiV2ReservationMFindData` \[\{v2Reservation\}\] v2Reservation 객체 배열
     */
    apiV2ReservationMFind: (query: ApiV2ReservationMFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMFindData, any>({
        path: `/v3/api/v2reservation/m/find`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMPossibledate
     * @summary 예약 가능 날짜의 조회 (모바일)
     * @request GET:/v3/api/v2reservation/m/possibledate
     * @secure
     * @response `200` `ApiV2ReservationMPossibledateData` \[\{Date\}\] 예약 가능한 날짜 배열
     */
    apiV2ReservationMPossibledate: (query: ApiV2ReservationMPossibledateParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMPossibledateData, any>({
        path: `/v3/api/v2reservation/m/possibledate`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMPossibletime
     * @summary 컬럼 ID 및 특정 일에 대한 다른 유효 예약건들 조회 (모바일)
     * @request GET:/v3/api/v2reservation/m/possibletime
     * @secure
     * @response `200` `ApiV2ReservationMPossibletimeData` 예약 가능 시간 배열 (hh\:mm 형태)
     */
    apiV2ReservationMPossibletime: (query: ApiV2ReservationMPossibletimeParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationMPossibletimeData, any>({
        path: `/v3/api/v2reservation/m/possibletime`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Reservation
     * @name ApiV2ReservationMUpdate
     * @summary 예약 수정 (모바일)
     * @request POST:/v3/api/v2reservation/m/update
     * @secure
     * @response `200` `ApiV2ReservationMUpdateData` \{v2Reservation\} 수정된 예약 컬렉션 객체
     */
    apiV2ReservationMUpdate: (
      data: {
        /** (required) 예약 id */
        _id?: string;
        /** (required) 병원 id */
        hospitalID?: string;
        /** (required) 병원서비스 id */
        hserviceID?: string;
        /** (required) 예약을 받을 고객의 id */
        userID?: string;
        /** (required) 예약 그룹(부서) id */
        groupID?: string;
        /** (required) 예약 컬럼(담당자) id */
        columnID?: string;
        /**
         * (required) 예약 시작 시간
         * @default "2024-02-23T09:00:00.000+0900"
         */
        startedAt?: string;
        /**
         * (required) 예약 종료 시간
         * @default "2024-02-23T09:30:00.000+0900"
         */
        endedAt?: string;
        /** (optional) 프로그램 id */
        programID?: string;
        /** (optional) 예약 상태 id */
        statusID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationMUpdateData, any>({
        path: `/v3/api/v2reservation/m/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
